import styles from './videospinnerloader.module.scss';

export const VideoSpinnerLoader = () => {
    return (
        <div className={styles.overlay}>
            <div className={styles.loaderWrapper}>
                <svg className={styles.spinner} viewBox="25 25 50 50">
                    <circle className={styles.path} cx="50" cy="50" r="20" fill="none" strokeMiterlimit="10" />
                </svg>
            </div>
        </div>
    );
};
